import { toastFn, toastSavedWithUndo } from "./toast";
import { confirm } from "./confirm-store";
import { Banner } from "./Banner";
import { Empty } from "./Empty";
import { QueryErrorState } from "./QueryErrorState";

export const Notify = {
  toast: toastFn,
  confirm,
  Banner,
  Empty,
  QueryError: QueryErrorState,
} as const;

export { toastSavedWithUndo };
export { QueryErrorState };

export { toast } from "./sonner-shim";

export { ConfirmHost } from "./ConfirmHost";

export type {
  NotifyVariant,
  NotifyToastOptions,
  NotifyConfirmOptions,
  NotifyBannerProps,
  NotifyEmptyProps,
} from "@/types/notify.types";
